import styled, {keyframes} from 'styled-components';
import {rem} from 'polished';
import {List, Button, Input} from 'global/styles/styles.js';
import StyledLoader from 'StyledLoader.js'

const BetSlipButtonBorderColor = ({theme:{$betSlipButtonBorderColor}}) => `${$betSlipButtonBorderColor}`;
const BetSlipButtonHoverColor = ({theme:{$betSlipButtonHoverColor}}) => `${$betSlipButtonHoverColor}`;

const BetSlipFormInputBackground = ({theme:{$betSlipFormInputBackground}}) => `${$betSlipFormInputBackground}`;
const BetSlipFormInputBorderColor = ({theme:{$betSlipFormInputBorderColor}}) => `${$betSlipFormInputBorderColor}`;
const BetSlipFormInputColor = ({theme:{$betSlipFormInputColor}}) => `${$betSlipFormInputColor}`;
const BetSlipFormLabelColor = ({theme:{$betSlipFormLabelColor}}) => `${$betSlipFormLabelColor}`;
const BetSlipPlaceBetSuccessBackground = ({theme:{$betSlipPlaceBetSuccessBackground}}) => `${$betSlipPlaceBetSuccessBackground}`;
const BetSlipPlaceBetSuccessColor = ({theme:{$betSlipPlaceBetSuccessColor}}) => `${$betSlipPlaceBetSuccessColor}`;
const BetSlipButtonsWrapperBackground = ({theme:{$betSlipButtonsWrapperBackground}}) => `${$betSlipButtonsWrapperBackground}`;
const BetSlipCheckboxWrapperBackground = ({theme:{$betSlipCheckboxWrapperBackground}}) => `${$betSlipCheckboxWrapperBackground}`;
const BetSlipFakeChboxBackground = ({theme:{$betSlipFakeChboxBackground}}) => `${$betSlipFakeChboxBackground}`;
const BetSlipChboxInputBorderColor = ({theme:{$betSlipChboxInputBorderColor}}) => `${$betSlipChboxInputBorderColor}`;
const BetSlipChboxLabelColor = ({theme:{$betSlipChboxLabelColor}}) => `${$betSlipChboxLabelColor}`;
const BetSlipFormGroupColor = ({theme:{$betSlipFormGroupColor}}) => `${$betSlipFormGroupColor}`;

const baseFont = `12px`;

const S = {};
const blinkAnimation = keyframes`
  0% {
    opacity: 0.9;
  }

  50% {
    opacity: 0.0;
  }

  100% {
    opacity: 0.9;
  }
`;

S.BetSlipWrapper = styled.div`
    font-family: "Roboto Condensed", sans-serif;
    position: relative;
    &.is-sticked{
        position: fixed;
        top: 0;
        width: inherit;
        z-index: 1;
        right: 0;
    }
`;

S.Info = styled.div`
   color: green;
   padding: 5px;
`;

S.BetSlipHeader = styled.div`
    width: 100%;
    padding: 1rem 0.5rem;
    font-family: "Roboto Condensed",sans-serif;
    font-size: 1.4rem;
    color: #CBD0D6;
    background-color: #777D85;
    display: flex;
     cursor: pointer;
`;

S.BetSlipBody = styled.div`
    overflow: hidden;
    position: relative;
    max-height: 1000px;
    transition-property: max-height;
    transition-duration: .5s;
    ${({isHidden}) => {
        return isHidden == true && 'max-height: 0';
    }}
`;

S.BetSlipContainer = styled.div`
    right: 500px;
    width: 100%;
    z-index: 1000000;
    min-height: 100px;
    background-color: #fff;
    padding: 0;
`;

S.Outcome = styled.div`
   padding: 5px 0;
   border-bottom: 1px solid grey;
   display: flex;
`;

S.PrevOdds = styled.span`
    position: relative;
    margin-left: 30px;
    &.up,
    &.down{
         padding-right: 25px;
         &:before{
              right: 5px;
              top: 4px;
              content: '';
              width: 0;
              height: 0;
              position: absolute;
              animation-direction: normal;
              animation-duration: 1.5s;
              animation-iteration-count: infinite;
              animation-name: ${blinkAnimation};
              animation-timing-function: ease;
          }
    }
    &.up{
        color: green;
        &:before{
            border-color: green transparent;
	        border-style: solid;
	        border-width: 0px 8px 8px 8px;
        }
    }
    &.down{
        color: red;
        &:before{
            border-color: red transparent;
	        border-style: solid;
	        border-width: 8px 8px 0px 8px;
        }
     }
`;

S.Error = styled.div`
   color: red;
   padding: 5px;
`;


S.BetSlipOverlay = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    justify-content: center;
    align-items: center;
    display: flex;
     z-index: 1;
     & ${StyledLoader.LoaderWrapper}{
        position: absolute;
    }
    
`;

S.ArrowIcon = styled.i`
    margin-left: auto;
    margin-right: 0.5rem;
`;

S.ClearBetSlip = styled(Button)`
    background-color: transparent;
    height: ${rem('45px', baseFont)};
    padding: 0  ${rem('20px', baseFont)};
    border-radius: 3px;
    border: 2px solid ${BetSlipButtonBorderColor};
    text-transform: uppercase;
    font-size: ${rem('12px', baseFont)};
    font-weight: bold;
    &:hover{
         background-color: ${BetSlipButtonHoverColor};
         color: #fff;
    }
`;

S.PlaceBet = styled(S.ClearBetSlip)`
    background-color: ${BetSlipButtonHoverColor};
    color: #fff;
`;

S.BetInShop = styled(S.ClearBetSlip)`
  background-color: ${BetSlipButtonHoverColor};
  color: #fff;
`;

S.AcceptTraderChanges = styled(S.ClearBetSlip)``;

S.RejectTraderChanges = styled(S.ClearBetSlip)``;

S.ButtonsWrapper = styled.div`
    background-color: ${BetSlipButtonsWrapperBackground};
    padding: ${rem('8px', baseFont)};
    display: grid;
    grid-gap: ${rem('3px', baseFont)} ${rem('3px', baseFont)}
    grid-template-columns: repeat(2, 50%);
`;

S.WinningTaxBox = styled.div`
    color: ${BetSlipChboxLabelColor};
    border: 1px solid #0000003D;
    border-radius: 3px;
    padding: 1rem;
    text-align: center;
    margin-bottom: 0.5rem;
`;

S.FormGroupWrapper = styled.div`
    display: flex;
    margin-bottom: 0.7rem;
    padding: 0 ${rem('8px', baseFont)};
`;

S.InputWrapper = styled.div`
    display: flex;
    border-radius: 4px;
    height: 2.7rem;
    padding: 0 0.5rem 0 0;
    width: 50%;
    color: ${BetSlipFormInputColor};
    background-color: ${BetSlipFormInputBackground};
    border: 1px solid ${BetSlipFormInputBorderColor};
`;

S.Input = styled(Input)`
    font-size: 1.3333rem;
    text-align: right;
    background-color: transparent;
    border: none;
    padding-right: 0.5rem;
    width: 100%;
    color: ${BetSlipFormInputColor};
    &[type="number"]{
      -moz-appearance:textfield;
    }
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button{
      -webkit-appearance: none;
       margin: 0;
    }
`;

S.Label =  styled.label`
    width: 50%;
    margin-top: 0.25rem;
    font-size: ${rem('14px', baseFont)};
    font-weight: normal;
    margin-bottom: 0;
    width: 50%;
    color: ${BetSlipFormLabelColor};
    align-self: center;
`;

S.Currency = styled.div`
    font-size: 1.3333rem;
    display: flex;
    align-items: center;
`;

S.EmptySlip = styled.div`
    padding: ${rem('10px', baseFont)};
`;

S.PlaceBetSuccess = styled.div`
    display: flex;
    flex-direction: column;
    margin: ${rem('8px', baseFont)};
`;

S.PlaceAgainBtn = styled(Button)`
    background-color: transparent;
    height: ${rem('45px', baseFont)};
    padding: 0  ${rem('20px', baseFont)};
    border-radius: 3px;
    border: 2px solid ${BetSlipButtonBorderColor};
    text-transform: uppercase;
    font-size: ${rem('12px', baseFont)};
    font-weight: bold;
`;

S.ClearBetSlipBtn = styled(S.PlaceAgainBtn)``;

S.PlaceBetSuccessTop = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: ${BetSlipPlaceBetSuccessBackground};
    color: ${BetSlipPlaceBetSuccessColor};
    border-radius: 3px;
    min-height: ${rem('125px', baseFont)};
    margin-bottom: ${rem('6px', baseFont)};
    padding: ${rem('17px', baseFont)};
`;

S.PlaceBetSuccessBottom = styled.div`
    display: grid;
    grid-gap: 0 ${rem('3px', baseFont)};
    grid-template-columns: repeat(2, 1fr);
`;

S.PlaceBetIcon = styled.div`
    width: ${rem('47px', baseFont)};
    height: ${rem('47px', baseFont)};
    margin-bottom: ${rem('8px', baseFont)};
`;

S.PlaceBetMessage = styled.div`
    font-weight: bold;
    font-size: ${rem('14px', baseFont)};
    text-align: center;
`;

S.CheckboxWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: ${rem('8px', baseFont)};
    background-color: ${BetSlipCheckboxWrapperBackground};
`;

S.CheckboxGroup = styled.div``;

S.LabelCheckbox = styled.label`
    display: flex;
    align-items: center;
    width: auto;
    height: auto;
`;

S.InputCheckbox = styled(Input)`
    position: absolute !important;
    clip: rect(1px 1px 1px 1px);
    clip: rect(1px, 1px, 1px, 1px);
    padding: 0 !important;
    border: 0 !important;
    height: 1px !important;
    width: 1px !important;
    overflow: hidden;

    &:checked + ${S.FakeCheckbox} {
        &:before {
            display: block;
        }
    }
`;

S.FakeCheckbox = styled.span`
    cursor: pointer;
    background-color: ${BetSlipFakeChboxBackground};
    margin-right: ${rem('15px', baseFont)};
    position: relative;
    width: 1.5rem;
    height: 1.5rem;
    display: inline-block;
    vertical-align: middle;
    flex-shrink: 0;
    border-radius: 2px;
    border: 1px solid ${BetSlipChboxInputBorderColor};
    &:before {
        content: "\\002714";
        position: absolute;
        display: none;
        left: 0.30rem;
        top: 0.05rem;
    }
`;

S.CheckboxText = styled.span`
    font-size: ${rem('12px', baseFont)};
    color: ${BetSlipChboxLabelColor};
    font-weight: normal;
    line-height: 1;
`;

S.FormGroup = styled.div`
    padding: ${rem('5px', baseFont)} ${rem('8px', baseFont)};
    display: flex;
    justify-content: space-between;
`;

S.FormGroupText =  styled.div`
  font-size: ${rem('14px', baseFont)};
  color: ${BetSlipFormGroupColor};
`;

S.UnexpectedError = styled.div`
   padding: ${rem('15px', baseFont)};
   border-radius: 3px;
   background-color: red;
   margin: ${rem('10px', baseFont)} 0 0;
   display: flex;
   align-items: center;
`;

S.UnexpectedErrorIcon = styled.div`
    flex-shrink: 0;
    font-size: ${rem('20px', baseFont)};
    margin-right: ${rem('10px', baseFont)};
`;

S.UnexpectedErrorMessage = styled.div``;

S.ErrorContainer = styled.div`
    margin-top: ${rem('10px', baseFont)};
    max-height: ${rem('55px', baseFont)};
    overflow-y: auto;
`;

export default S;